import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {setMessage} from './message';

import dieQuotationService from '../services/die-quotation.service';


export const fetchDieQuotationList = createAsyncThunk(
    'dieQuotation/fetchDieQuotationList',
    async ({page, pagesize, search, ordering}, thunkAPI) => {
        try {
            const response = await dieQuotationService.getDieQuotationList(page, pagesize, search, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                error.response.data &&
                error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);

export const fetchArchivedDieQuotationList = createAsyncThunk(
    'dieQuotation/fetchArchivedDieQuotationList',
    async ({page, pagesize, search, ordering}, thunkAPI) => {
        try {
            const response = await dieQuotationService.getArchiveDieQuotationList(page, pagesize, search, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                error.response.data &&
                error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);
export const fetchDieQuotationById = createAsyncThunk(
    'dieQuotation/fetchDieQuotationById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await dieQuotationService.getDieQuotationById(id);
            return response.data; // Return the profile data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const fetchViewDieQuotationById = createAsyncThunk(
    'dieQuotation/fetchViewDieQuotationById',
    async ({ id }, thunkAPI) => {
        try {
            const response = await dieQuotationService.getViewDieQuotationById(id);
            return response.data; // Return the profile data
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const createDieQuotation = createAsyncThunk(
    'dieQuotation/createDieQuotation',
    async ({ values }, thunkAPI) => {
        try {
            const response = await dieQuotationService.PostDieQuotation(values);
            return response.data;
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const updateDieQuotation = createAsyncThunk(
    'dieQuotation/updateDieQuotation',
    async ({ id, values}, thunkAPI) => {
        try {
            const response = await dieQuotationService.editDieQuotation(id, values);
            return response.data; // Return the updated die group data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteDieQuotation = createAsyncThunk(
    'dieQuotation/deleteDieQuotation',
    async (id, thunkAPI) => {
        try {
            await dieQuotationService.deleteDieQuotation(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);


export const unArchiveDieQuotation = createAsyncThunk(
    'dieQuotation/unArchiveDieQuotation',
    async (id, thunkAPI) => {
        try {
            await dieQuotationService.unArchiveDieQuotation(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const initialState = {
    data: [], // List
    list: [],
    totalPages: 0,
    currentPage: 1,
    totalRecord: 0,
    status: 'idle',
    error: null,
    loading: false,
    hasMore: true,
};


const dieQuotationSlice = createSlice({
    name: 'dieQuotation',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetDieQuotationData: (state) => {
            state.data = []; // This will clear the list
        },
        resetDieQuotationList: (state) => {
            state.list = []; // This will clear the list
        },
        resetCurrentDieQuotationPage: (state) => {
            state.currentPage = 1;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchDieQuotationList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDieQuotationList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchDieQuotationList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });
        builder
            .addCase(fetchArchivedDieQuotationList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchArchivedDieQuotationList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedDieQuotationList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });
        builder
            .addCase(fetchDieQuotationById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDieQuotationById.fulfilled, (state, action) => {
                state.loading = false;
                state.activeProfileRecord = action.payload;
            })
            .addCase(fetchDieQuotationById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(createDieQuotation.pending, state => {
                state.status = 'loading';
            })
            .addCase(createDieQuotation.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(createDieQuotation.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
        builder
            .addCase(updateDieQuotation.pending, state => {
                state.status = 'loading';
            })
            .addCase(updateDieQuotation.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const updateDieQuotation = action.payload;
                const index = state.data.findIndex(group => group.id === updateDieQuotation.id); // Find the index of the updated group
                if (index !== -1) {
                    state.data[index] = updateDieQuotation; // Replace the old group with the updated one
                }
            })
            .addCase(updateDieQuotation.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(deleteDieQuotation.pending, state => {
                state.status = 'loading';
            })
            .addCase(deleteDieQuotation.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(deleteDieQuotation.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(unArchiveDieQuotation.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveDieQuotation.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveDieQuotation.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetDieQuotationData, resetDieQuotationList, resetCurrentDieQuotationPage } = dieQuotationSlice.actions;
export default dieQuotationSlice.reducer;
